import { render, staticRenderFns } from "./profession.vue?vue&type=template&id=360236fa&scoped=true&"
import script from "./profession.vue?vue&type=script&lang=ts&"
export * from "./profession.vue?vue&type=script&lang=ts&"
import style0 from "./profession.vue?vue&type=style&index=0&id=360236fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "360236fa",
  null
  
)

export default component.exports